import React, { useEffect, useState } from 'react';
import { X } from 'lucide-react';
export interface Project {
  caseNumber: string;
  category: string;
  title: string;
  description: string;
  image: string;
  slug: string;
  url: string;
}
interface ProjectModalProps {
  project: Project;
  onClose: () => void;
}
export function ProjectModal({
  project,
  onClose
}: ProjectModalProps) {
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    // trigger the entrance animation on mount
    const raf = requestAnimationFrame(() => setVisible(true));
    return () => cancelAnimationFrame(raf);
  }, []);
  useEffect(() => {
    const onKeyDown = (e: KeyboardEvent) => {
      if (e.key === 'Escape') onClose();
    };
    window.addEventListener('keydown', onKeyDown);
    return () => window.removeEventListener('keydown', onKeyDown);
  }, [onClose]);
  return <div className={`fixed inset-0 bg-black/90 z-50 flex items-center justify-center p-3 sm:p-6 transition-opacity duration-200 ${visible ? 'opacity-100' : 'opacity-0'}`} onClick={onClose} data-id="element-219" data-mp="1ioep6ul0257z">
      <div className={`relative w-full sm:w-auto max-w-[95vw] max-h-[90vh] transition-all duration-200 ${visible ? 'opacity-100 scale-100' : 'opacity-0 scale-95'}`} onClick={e => e.stopPropagation()} data-id="element-220" data-mp="6jh773csmmu7">
        <button onClick={onClose} aria-label="Close" className="absolute -top-3 -right-3 sm:top-4 sm:right-4 z-10 w-9 h-9 sm:w-10 sm:h-10 bg-black text-white rounded-full hover:bg-white/10 transition-colors flex items-center justify-center border border-white/20" data-id="element-221" data-mp="gglsz22q8gah">
          <X className="w-4 h-4 sm:w-5 sm:h-5" data-id="element-222" data-mp="3owotmnvf94pb" />
        </button>

        <img src={project.image} alt={project.title} className="max-w-full max-h-[90vh] w-auto h-auto rounded-xl sm:rounded-2xl border border-white/10 shadow-2xl object-contain" data-id="element-223" data-mp="3tooy8tmfsls8" />
      </div>
    </div>;
}